import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import {makeStyles} from "@mui/styles";
import {useEffect, useState} from "react";
import {toast} from "react-toastify";


const Form_SB_16 = props => {
    const {matterContacts, selectedMatter, selectedForm, xfaCombinedData, setXfaCombinedData, xfaGeneratedForm, modify} = props;

    const initialState = {
        correspondenceAddress: {
            type: "customer-number"
        },
        inventionSection: {
            negation: true,
            governmentAgency: false,
            governmentContract: false,
            governmentAgencyName: "",
            governmentContractNumber: ""
        },
    };

    const [state, setState] = useState(initialState);

    const {
        correspondenceAddress: {type},
        inventionSection: {negation, governmentAgency, governmentContract, governmentAgencyName, governmentContractNumber}
    } = state || initialState;

    useEffect(() => {
        const selectedItem = xfaCombinedData?.find(xfaData => xfaData.form_id === selectedForm && xfaData.matter_id === selectedMatter);

        if (modify) {
            if (selectedItem) {
                if (xfaGeneratedForm?.statusCode === 500) {
                    toast.error("Failed to preview the form");
                } else {
                    selectedItem.data = xfaGeneratedForm;
                    setState(xfaGeneratedForm);
                }
            }
        }
    }, []);

    useEffect(() => {
        const selectedItem = xfaCombinedData?.find(xfaData => xfaData.form_id === selectedForm && xfaData.matter_id === selectedMatter);
        if (selectedItem?.data) {
            setState(selectedItem.data);
        } else {
            setState(initialState);
        }
    }, [selectedMatter, selectedForm]);

    useEffect(() => {
        setXfaCombinedData && setXfaCombinedData(previousData => {
            const newData = JSON.parse(JSON.stringify(previousData));

            const item = newData?.find(xfaData => xfaData.form_id === selectedForm && xfaData.matter_id === selectedMatter);

            if (item) {
                if (!item.data) {
                    item.data = {};
                }
                item.data = state;
            }

            return newData;
        });
    }, [state]);

    const useStyles = makeStyles({
        smallRadio: {
            "& svg": {
                width: 20,
                height: 20
            },
            "& svg > circle": {
                width: 12,
                height: 12
            }
        },
        smallCheckbox: {
            "& svg": {
                width: 20,
                height: 20
            }
        },
        table: {
            border: "1px solid black"
        },
        row: {
            "&:nth-of-type(odd)": {
                backgroundColor: "#F5F5F5"
            },
            "&:nth-of-type(even)": {
                backgroundColor: "white"
            }
        }
    });

    const classes = useStyles();

    const handleChange = event => {
        let {name, type, checked, value} = event.target;
        const [mainKey, subKey] = name.split(".");

        if (subKey) {
            if (subKey === "negation" || subKey === "governmentAgency" || subKey === "governmentContract") {
                setState(prevState => ({
                    ...prevState,
                    [mainKey]: {
                        ...prevState[mainKey],
                        negation: checked ? subKey === "negation" : false,
                        governmentAgency: checked ? subKey === "governmentAgency" : false,
                        governmentContract: checked ? subKey === "governmentContract" : false
                    }
                }));
            } else {
                setState(prevState => ({
                    ...prevState,
                    [mainKey]: {
                        ...prevState[mainKey],
                        [subKey]: type === "checkbox" ? checked : value
                    }
                }));
            }
        } else {
            if (name !== "signatories") {
                setState(prevState => ({
                    ...prevState,
                    [name]: type === "checkbox" ? checked : value
                }));
            }
        }
    };

    const correspondenceAddressLabel1 = "The address corresponding to Customer Number";
    const correspondenceAddressLabel2 = "Firm or Individual Name";

    const inventionLabel1 = "Yes, the invention was made by an agency of the United States Government. The U.S. Government agency name is:";
    const inventionLabel2 = "Yes, the invention was under a contract with an agency of the United States Government. The name of the U.S. Government agency and Government contract number are";

    const inventionSection = "The invention was made by an agency of the United States Government or under a contract with an agency of the United States Government.";

    return (
        <div>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#D3D3D3",
                    color: "black",
                    padding: 0
                }}
            >
                <Box/>
                <Box>Form SB-16</Box>
            </Box>
            <Box sx={{marginTop: "3%"}}>
                <Paper>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} md={4} lg={2}>
                            <Typography sx={{marginLeft: "2%"}}>Correspondence Address</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={10}>
                            <RadioGroup name="correspondenceAddress.type" value={type} onChange={handleChange}>
                                <FormControlLabel value="customer-number" control={<Radio className={classes.smallRadio}/>} label={correspondenceAddressLabel1}/>
                                <FormControlLabel value="firm-or-individual" control={<Radio className={classes.smallRadio}/>} label={correspondenceAddressLabel2}/>
                            </RadioGroup>
                        </Grid>
                    </Grid>
                    <br/>
                </Paper>
            </Box>
            <Box sx={{
                marginTop: "3%",
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
                minHeight: "50vh"
            }}>
                <Paper sx={{flexGrow: 1, display: "flex", flexDirection: "column"}}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} md={4} lg={2}>
                            <Typography sx={{marginLeft: "2%"}}>{inventionSection}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={10}>
                            <FormControlLabel name="inventionSection.negation" control={<Checkbox className={classes.smallCheckbox} checked={negation} onChange={handleChange}/>} label="No"/>
                            <br/>
                            <FormControlLabel name="inventionSection.governmentAgency" control={<Checkbox className={classes.smallCheckbox} checked={governmentAgency} onChange={handleChange}/>} label={inventionLabel1}/>
                            <br/>
                            <FormControlLabel name="inventionSection.governmentContract" control={<Checkbox className={classes.smallCheckbox} checked={governmentContract} onChange={handleChange}/>} label={inventionLabel2}/>
                            <br/>
                            <br/>
                            {!negation && <div style={{marginLeft: "3%"}}>
                                {(governmentAgency || governmentContract) && <>
                                    <Typography>U.S. Government agency name</Typography>
                                    <TextField name="inventionSection.governmentAgencyName" value={governmentAgencyName} size="small" label="" fullWidth={false} onChange={handleChange}></TextField>
                                    <br></br>
                                    <br></br>
                                </>}
                                {governmentContract && <><Typography>U.S. Government contract number</Typography>
                                    <TextField name="inventionSection.governmentContractNumber" value={governmentContractNumber} size="small" label="" fullWidth={false} onChange={handleChange}></TextField>
                                </>}
                            </div>}
                        </Grid>
                    </Grid>
                    <br></br>
                </Paper>
            </Box>
        </div>
    );
};


export default Form_SB_16;